import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";
import {AbstractControl, FormControl, Validators} from "@angular/forms";

@Component({
	templateUrl: './change_currency.component.html'
})
export class ChangeCurrencyModalComponent extends BaseSupportModalComponent {
	title: string;
	userId: string;
	oldCurrency: string = '';
	newCurrency: string = '';

	ngOnInit() {
		const me = this;
		this.spreader.base.form = this.form;

		this.form.addControl('newCurrency', new FormControl('',[
			this.getStandartValidator('newCurrency_required', Validators.required, '"Новая валюта" - обязательное поле'),
			this.getCustomValidator('newCurrency_notOldCurrency', function(name: string, control: AbstractControl) {
				const isInvalid = (control.value === me.oldCurrency);

				let err = {};
				err[name] = {value: control.value, message: `"Новая валюта" - не может быть '${me.oldCurrency}'`};

				return isInvalid ? err : null;
			})
		]));
	}	

	async ok() {
		if (confirm(`Подтвердите смену валюты для пользователя ${this.title}?`)) {
			await this.supportService.changeCurrency(this.userId, this.newCurrency, this.spreader.base.comment).toPromise();

			this.execute();
		}
	}
}
